// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"ddab0f7f","320":"ba5b1665","505":"c3348dfd","810":"3afb5c35"}[chunkId] + ".chunk.css";
};